<div
  style="
    background-image: url('../../../../assets/imagesNew/Proceed2.png') !important;
    background-size: cover;
    height: 100vh;
  "
>
  <div
    style="
      height: 100%;
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    "
  >
    <div
      style="
        background-color: white;
        padding-bottom: 10px;
        border-radius: 8px;
        align-items: center;
      "
    >
      <h5
        style="
          text-align: center;
          font-size: 22px;
          color: white;
          background-color: #637fb7;
          padding-top: 10px;
          height: 44px;
        "
        class="mb-0 mb-4"
      >
        Great things are underway
      </h5>

      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 16px;
        "
        class="p-3"
      >
        <span>
          <img
            src="/../../../assets/imagesNew/underm1.png"
            alt="Warning Icon"
            style="width: 500px; height: 300px"
          />
        </span>
        <hr />
        <p style="text-align: center; color: red" class="mb-0">
          Carefinity is temporary unavailable due to scheduled maintenance. It
          will be accessible Shortly.<br />
          We apologise for the inconvenience and ask your patience.
        </p>
      </div>
    </div>
  </div>
</div>
